import React from 'react';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const CommerceDownloadsItem = Atom.createRender(
  ({attributes, classes, data, generateAttributes, renderChild}) => {
    return (
      <div {...generateAttributes(attributes, classes)}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </div>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Download Item',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Dynamo'), iconName('CollectionItem')),
  },
  showEmpty: false,
  render: CommerceDownloadsItem,
  constraints: {
    ancestors: [{is: 'CommerceDownloadsList', rule: 'ExactlyOne'}],
    pinToParent: true,
  },
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'grid',
          gridTemplateColumns: '1fr max-content',
          gridColumnGap: px(16),
          alignItems: 'center',
          marginBottom: px(20),
        },
      },
    },
  },
  fields: {children: TListOfElement},
});

export default config;
